<template>
	<Page class="christmas-offer-home">
		<template v-slot:content>
			<SafeAreaTop class="christmas-offer-home__safe-area" @close="onClose" closePosition="left" theme="dark-invert" />

			<img class="christmas-offer-home__img" src="@/assets/christmas-offer-pre-bg.png" alt="Image with pines" />
			
			<div class="christmas-offer-home__content container">
				<ChristmasOfferGoal 
					:name="user.name"
					:is-metric="user.usesMetricSystem"
					:target-weight="user.targetWeight"
					:days-to-goal="user.data.predictiveWeightLossDaysToGoal"
				/>
				<ChristmasOfferChart
					:is-metric="user.usesMetricSystem"
					:weight="user.weight"
					:target-weight="user.targetWeight"
					:days-to-goal="user.data.predictiveWeightLossDaysToGoal"
				/>
				<ChristmasOfferProgramBenefits />
			</div>
		</template>

		<template v-slot:footer>
			<div class="container">
				<Button @click="goNext" class="btn christmas-offer-home__btn btn-green">{{ t('offers.christmas.pre.continue_btn') }}</Button>
			</div>
		</template>
	</Page>
</template>

<style lang="scss" scoped>
.christmas-offer-home {
	&__safe-area {
		position: absolute;
	}

	&__content {
		margin-top: 0.8rem;
	}

	&__img {
		max-width: 435px;
    	width: 100%;
		margin: auto;
		display: block;
	}

	&__btn {
		width: 100%;
		font-weight: 600;
		background: linear-gradient(90.05deg, #52a376 0.03%, #50a373 98.26%);
		border-radius: 100px;
		border: none;
	}
}
</style>

<script>
import { inject, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

import useApi from '@/composition/api.js'

import Page from '@/components/Page'
import SafeAreaTop from '@/components/SafeAreaTop'
import Button from '@/components/Button.vue'
import ChristmasOfferGoal from '../../components/christmas-offer/ChristmasOfferGoal.vue'
import ChristmasOfferChart from '../../components/christmas-offer/ChristmasOfferChart.vue'
import ChristmasOfferProgramBenefits from '../../components/christmas-offer/ChristmasOfferProgramBenefits.vue'

export default {
	components: {
		Page,
		SafeAreaTop,
		Button,
		ChristmasOfferGoal,
		ChristmasOfferChart,
		ChristmasOfferProgramBenefits
	},
	setup() {
		const { t } = useI18n()
		const amplitude = inject('amplitude')
		const router = useRouter()
		const api = useApi()
		const store = useStore()

		const user = computed(() => store.state.user.data || { data: {} })

		onMounted(() =>
		setTimeout(() => amplitude.logEvent(store.getters['getAmplitudeEventName']('PrePaywallShow'), {
				data_source: 'client',
				offer: 'Christmas2022'
			}), 3000)
		)

		const onClose = () => {
			amplitude.logEvent(store.getters['getAmplitudeEventName']('PrePaywallDone'), {
				data_source: 'client',
				action: 'close',
				offer: 'Christmas2022'
			}) 
			api.close()
		}

		const goNext = () => {
			amplitude.logEvent(store.getters['getAmplitudeEventName']('PrePaywallDone'), {
				data_source: 'client',
				action: 'continue',
				offer: 'Christmas2022'
			}) 
			router.push({ name: 'christmas-offer-paywall' })
		}

		return {
			t,
			onClose,
			user,
			goNext
		}
	}
}
</script>
